import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import Constants
import { l } from 'constants/common';
// Import Components
import { CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
// Import Services
import { getTimeSpanValue } from 'services/customerJourney/helpers';

const CJTimeSpanInfoBlock = ({ data }) => {
    const { t } = useTranslation();

    const value = getTimeSpanValue(data?.value);

    return (
        <>
            <CJInfoBlockLabelValueWrapper label={t(l.Day)} value={value?.day} />
            <CJInfoBlockLabelValueWrapper label={t(l.Time)} value={value?.time} />
        </>
    );
};

CJTimeSpanInfoBlock.propTypes = {
    data: PropTypes.object.isRequired,
};

export default memo(CJTimeSpanInfoBlock);
